import { Grid } from "@mui/material";
import dynamic from "next/dynamic";

import FullScreenImageDisplay from "@/components/FormRateLayout/MultipleImageDisplay/FullScreenImageDisplay";
import { useFullScreenImage } from "@/components/FormRateLayout/MultipleImageDisplay/useFullScreenImage";
import { ThemedBottomSelector } from "@/features/FormV2/sharedComponents/ThemedItemBlock/ThemedMultipleImageDisplay/ThemedBottomSelector";
import { FormZeffyLoader } from "@/forms-design-system/FormZeffyLoader";

// eslint-disable-next-line react/display-name
const Image = dynamic(() => import("@/components/Image/Image"), { loading: () => <FormZeffyLoader /> });

interface MultipleImageDisplayProps {
  photoUrls: string[];
  title: string;
}

const ThemedDesktopMultipleImageDisplay = ({ photoUrls, title }: MultipleImageDisplayProps) => {
  const size = 140;
  const hasMultipleImages = photoUrls.length > 1;

  const { displayedImageIndex, isFullScreen, goLeft, goRight, closeFullScreen, openFullScreen, setSelectedIndex } =
    useFullScreenImage();

  return (
    <Grid item sx={{ width: size }}>
      <FullScreenImageDisplay
        photoUrls={photoUrls}
        title={title}
        displayedImageIndex={displayedImageIndex}
        isFullScreen={isFullScreen}
        goLeft={goLeft}
        goRight={goRight}
        closeFullScreen={closeFullScreen}
        setSelectedIndex={setSelectedIndex}
      />
      <Grid container sx={{ width: size }}>
        <Grid item xs={12} sx={{ position: "relative", overflow: "hidden", width: size, height: size }}>
          <Grid
            container
            direction="row"
            sx={{
              position: "absolute",
              top: 0,
              left: -size * displayedImageIndex,
              height: size,
              width: size * 3,
              transition: "left 0.2s ease-in-out",
            }}
          >
            {photoUrls.map((photoUrl, index) => (
              <Grid item key={index + photoUrl} sx={{ cursor: "zoom-in" }} onClick={openFullScreen}>
                <Image
                  nextImage
                  src={photoUrl}
                  alt={title ? `${title} item` : "item"}
                  width={size}
                  height={size}
                  objectFit="cover"
                  data-test="rate-image"
                  resolution={size * 2}
                  sx={{ borderRadius: "8px" }}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
        {hasMultipleImages && (
          <Grid item xs={12} marginTop={0.5}>
            <ThemedBottomSelector
              displayedImageIndex={displayedImageIndex}
              goLeft={goLeft}
              goRight={goRight}
              photoUrls={photoUrls}
              setSelectedIndex={setSelectedIndex}
              size="small"
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default ThemedDesktopMultipleImageDisplay;
